export enum ADMINISTRATION_KIND {
  INDIVIDUALLY = 1,
  SEPARATELY = 2,
  JOINTLY = 3,
  INDISTINCTLY = 4,
  UNDETERMINED = 5,
  A_NON_MEMBER_REPRESENTATIVE = 6,
  OTHER = 100,
}

export const ADMINISTRATION_KINDS = [
  {
    value: ADMINISTRATION_KIND.INDIVIDUALLY,
    displayName: 'individualmente',
  },
  {
    value: ADMINISTRATION_KIND.SEPARATELY,
    displayName: 'separadamente',
  },
  {
    value: ADMINISTRATION_KIND.JOINTLY,
    displayName: 'conjuntamente',
  },
  {
    value: ADMINISTRATION_KIND.INDISTINCTLY,
    displayName: 'indistintamente',
  },
  {
    value: ADMINISTRATION_KIND.UNDETERMINED,
    displayName: 'no determinado',
  },
  {
    value: ADMINISTRATION_KIND.A_NON_MEMBER_REPRESENTATIVE,
    displayName: 'un representante no socio',
  },
  {
    value: ADMINISTRATION_KIND.OTHER,
    displayName: 'otro',
  },
];

export enum ADMINISTRATION_ROLE {
  ADMINISTRATOR = 1,
  GENERAL_MANAGER = 2,
  ADMINISTRATORS = 3,
  DIRECTOR = 4,
  OTHER = 100,
}

export const ADMINISTRATION_ROLES = [
  {
    value: ADMINISTRATION_ROLE.ADMINISTRATOR,
    displayName: 'administrador',
  },
  {
    value: ADMINISTRATION_ROLE.GENERAL_MANAGER,
    displayName: 'gerente general',
  },
  {
    value: ADMINISTRATION_ROLE.ADMINISTRATORS,
    displayName: 'administradores',
  },
  {
    value: ADMINISTRATION_ROLE.DIRECTOR,
    displayName: 'director',
  },
  {
    value: ADMINISTRATION_ROLE.OTHER,
    displayName: 'otro',
  },
];
